import colors from '../colors'

const asiamiles = {
  bubble: {
    background: colors.divitDarkPurple,
    text: colors.white,
  },
  ticket: {
    primary: colors.asiamilesYellow,
    secondary: colors.asiamilesYellow, // to-do
  },
  backButton: {
    text: colors.asiamilesYellow,
  },
}

export default asiamiles
